<p *ngIf="mapError" role="status" class="alert alert-info">{{mapError}}</p>
<div *ngIf="isLoading == true" class="row h-100 justify-content-center align-items-center">
  <div class="text-center">
    <br>
    <br>
    {{ 'LOADING_MAP' | translate }}</div>
</div>
<div *ngIf="isLoading == false && memberLocArr.length == 0" class="row h-100 justify-content-center align-items-center">
  <div class="text-center">
    <br>
    <br>
    {{ 'NO_VALID_ADDRESSES_SELECTED' | translate }}</div>
</div>
<div #map style="width:100%;height: 100vh"></div>
